// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__k1_ut","spin":"loader_spin__gimJS","simple_loading":"loader_simple_loading__JrBP6","pulse":"loader_pulse__YBKcO"};